import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, isRef as _isRef, createCommentVNode as _createCommentVNode } from "vue"

import {computed, ref} from 'vue';
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import ForwardToOperatorEventInterface
    from "~/operatorApplication/vue/dialogs/dialog/topmenu/ForwardToOperatorEventInterface";
import PopoverMenu from "~/core-ui/vue/ui/popover-menu/PopoverMenu.vue";
import PopoverMenuItem from "~/core-ui/vue/ui/popover-menu/PopoverMenuItem.vue";
import {ForwardGroupsInterface} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/ForwardGroupsInterface";
import ObjectHelper from "~/ts/library/ObjectHelper";
import FilterablePopover from "~/core-ui/vue/ui/FilterablePopover.vue";
import OperatorApplicationForwardButtonOperator
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationForwardButtonOperator.vue";


const __default__ = {
    name: "OperatorApplicationForwardButton"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    site: {},
    groups: {},
    groupSelectable: { type: Boolean }
  },
  emits: ["forward"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let filter = ref<string>();

let canViewLogin = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin;
});

function forwardToGroup(groupId: string) {
    if (props.groupSelectable) {
        if (groupId) {
            forwardToOperator(null, groupId)
        }
    }
}

function forwardToOperator(operatorLogin: string, groupId: string) {
    emits("forward", {operatorLogin, groupId} as ForwardToOperatorEventInterface);
}

let displayedGroups = computed(() => {
    let filterString = (filter.value ?? "").trim().toLowerCase();
    if (filterString.length > 0) {
        let result = ObjectHelper.jsonClone(props.groups);
        return result.filter(group => {
            group.operators = group.operators.filter(operator => operator.fio.toLowerCase().includes(filterString) || operator.login.toLowerCase().includes(filterString));
            if (!group.operators.length && (!group.id || !group.descr.toLowerCase().includes(filterString))) {
                return false;
            }
            return true;
        });
    } else {
        return props.groups;
    }
});


return (_ctx: any,_cache: any) => {
  return (__props.groups.length)
    ? (_openBlock(), _createBlock(FilterablePopover, {
        key: 0,
        modelValue: _unref(filter),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filter) ? (filter).value = $event : filter = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedGroups), (group) => {
            return (_openBlock(), _createElementBlock("div", {
              key: group.id,
              class: "group"
            }, [
              _createVNode(PopoverMenu, null, {
                default: _withCtx(() => [
                  _createVNode(PopoverMenuItem, {
                    bold: "",
                    disabled: !group.id || !__props.groupSelectable,
                    onClick: ($event: any) => (forwardToGroup(group.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(group.descr), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.operators, (operator) => {
                    return (_openBlock(), _createBlock(PopoverMenuItem, {
                      class: "operator-item",
                      key: operator.id,
                      onClick: ($event: any) => (forwardToOperator(operator.login, group.id))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(OperatorApplicationForwardButtonOperator, {
                          operator: operator,
                          "site-id": __props.site?.id
                        }, null, 8, ["operator", "site-id"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})